module.exports = __webpack_public_path__ + "img/share_blog.c66ecdc1.svg";